/**
 * 盤面のカードを「持ち主」と「今ある場所」で集める（Issue #317。引いたカードの選択で使う）。
 *
 * board は duel_info 互換（ocgcore/service/board.py）で、全ゾーンのカードに card_id / owner / controller / location がある。
 * 相手の場にあるカード（コントロール奪取など）も持ち主で拾う。エクストラデッキ・トークンは引けないので出さない。
 */
export const PICK_LOCATIONS = ['hand', 'monster_field', 'magic_trap', 'grave', 'removed', 'maindeck'];
export const LOCATION_JA = {
  hand: '手札', monster_field: 'モンスターゾーン', magic_trap: '魔法・罠ゾーン', grave: '墓地', removed: '除外', maindeck: 'デッキ',
};

const isCard = (c) => c && c.card_id && String(c.card_id) !== '00000000';

/**
 * team が持ち主のカードを場所ごとに。[{ location, label, cards: [{ key, code, name, image, count, controller }] }]（空の場所は出さない）。
 * デッキは同じカードをまとめて count にする（40 枚並べると選べない）。他の場所は 1 枚ずつ。
 */
export function ownedCardsByLocation(board, team, { names = {}, thumbs = {} } = {}) {
  if (!board) return [];
  const groups = [];
  for (const location of PICK_LOCATIONS) {
    const cards = [];
    for (const player of [0, 1]) {
      for (const [i, c] of (board[location]?.[player] ?? []).entries()) {
        if (!isCard(c) || c.owner !== team) continue;
        const code = String(c.card_id);
        const entry = { key: `${location}:${player}:${i}:${c.unique_id ?? ''}`, code, name: names[code] ?? code, image: thumbs[code] ?? null,
          count: 1, controller: c.controller ?? player };
        if (location === 'maindeck') {
          const same = cards.find((x) => x.code === code);
          if (same) { same.count += 1; continue; }
        }
        cards.push(entry);
      }
    }
    if (location === 'maindeck') cards.sort((a, b) => a.name.localeCompare(b.name, 'ja'));
    if (cards.length) groups.push({ location, label: LOCATION_JA[location], cards });
  }
  return groups;
}
